/**
 * Ruta a la que se navega al abrir un evento.
 *
 * Los eventos con `isEventInfo === true` (lo envía el backend en getEventsToStore)
 * muestran primero la página informativa; el resto va directo a la compra.
 * Es la única fuente de esta regla: no comparar ids de eventos en los componentes.
 */
export const getEventPath = (
    eventKey: string | number | null | undefined,
    isEventInfo?: boolean | null
): string => {
    const key = eventKey ?? '';
    return isEventInfo === true
        ? `/event-info/${key}`
        : `/event/eventDetail/${key}`;
};
